import React from 'react';
import { Button, Icon } from '@nearst/ui';

import { Link } from 'react-router-dom';
import RestrictedPage from '@components/RestrictedPage/RestrictedPage';
import { useShop } from '@services/ShopProvider';

export default function NotFound() {
	return (
		<RestrictedPage>
			<Icon>find_in_page</Icon>
			<h1>Page not found</h1>
			<p>The page you tried to access doesn't exist, or has been moved.</p>
			<Button as={Link} to="/" primary>
				Back home
			</Button>
		</RestrictedPage>
	);
}

export function ItemNotFound() {
	const { shop } = useShop();
	return (
		<RestrictedPage>
			<Icon>find_in_page</Icon>
			<h1>Item not found</h1>
			<p>This product is not stocked in the selected location.</p>
			<Button as={Link} to={`/inventory/${shop.id}/items`} primary>
				Back to inventory
			</Button>
		</RestrictedPage>
	);
}
